import env from '../../../../config/environment'

class Contratos {
    static get $inject() {
        return ["$scope", "$element", "$timeout", "$state", "$http", "gql"]
    }

    constructor(scope, element, timeout, $state, http, gql) {
        this.apply = fn => scope.$applyAsync(fn)
        this.watch = scope.$watch.bind(scope)
        this.element = element
        this.timeout = timeout
        this.routeParams = $state.params
        this.$state = $state
        this.http = http
        this.gql = gql

        this.contratos = []
        this.isCpfCnpjValid = true
    }

    $onInit() {
        this.initialPromise = this
            .loadContratos()
            .then(contratos => this.contratos = contratos.sortBy(contrato => contrato.nome))
            .then(() => {
                this.watch(() => this.routeParams, () => {
                    if (this.routeParams.contratoId) {
                        if (this.routeParams.contratoId == 'novo') {
                            this.selectContrato({})
                        } else {
                            const contrato = this.contratos.find(contrato => {
                                return contrato.id == this.routeParams.contratoId
                            })

                            this.selectContrato(contrato)
                        }
                    } else {
                        this.contrato = null
                    }
                })
            })
            .finally(() => this.apply())
    }

    selectContrato({ id, paymentMethodCode, ...contrato }) {
        const { perfilPagamento, ...cliente } = contrato.cliente || {}

        if (cliente.cidade) {
            cliente.cidade = { nome: cliente.cidade, estado: { sigla: cliente.estado } }
        }

        this.tipoDocumento = cliente.cpfCnpj && cliente.cpfCnpj.length == 11 ? "CPF" : "CNPJ"
        this.paymentMethodCode = paymentMethodCode ? paymentMethodCode : this.paymentMethodCode

        this.contrato = { id, paymentMethodCode }
        this.cliente = { ...cliente }
        this.perfilPagamento = perfilPagamento ? { ...perfilPagamento } : null
    }

    setFocusToInput(name) {
        this.element.context.querySelector(`[name=${name}]`).focus()
    }

    identificarBandeiraCartao() {
        this.perfilPagamentoCartaoCreditoForm.numeroCartao.$setValidity("unsupported", true)

        const numeroCartao = this.perfilPagamento.numeroCartao

        if (numeroCartao && numeroCartao.length == 16) {
            const regexBandeiras = {
                visa: /^4[0-9]{12}(?:[0-9]{3})/,
                mastercard: /^5[1-5][0-9]{14}/,
                hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
                elo: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/
            }

            Object.keys(regexBandeiras).forEach(bandeira => {
                if (regexBandeiras[bandeira].test(numeroCartao)) {
                    this.perfilPagamento.codigoBancoBandeira = bandeira
                }
            })

            if (!this.perfilPagamento.codigoBancoBandeira) {
                this.perfilPagamentoCartaoCreditoForm.numeroCartao.$setValidity("unsupported", false)
            }
        } else {
            this.perfilPagamento.codigoBancoBandeira = undefined
        }
    }

    clienteFormSubmit() {
        if (this.clienteForm && this.clienteForm.$valid) {
            const cidade = this.cliente.cidade

            const contrato = {
                id: this.contrato.id,
                cliente: {
                    ...this.cliente,
                    pais: "BR",
                    estado: cidade.estado.sigla,
                    cidade: cidade.nome
                }
            }

            const promise = contrato.id
                ? this.updateContratoCliente(contrato)
                : this.createContrato(contrato)

            this.clienteSavePromise = promise
                .then((contrato) => {
                    this.clienteForm.$setPristine()
                    this.$state.go('layout.contratos', { contratoId: contrato.id }, {notify: false})
                    this.clienteForm.saveFailed = false
                    this.clienteForm.saveSuccess = true
                    
                    this.timeout(() => {
                        if (this.clienteForm) this.clienteForm.saveSuccess = false;
                    }, 1000)
                })
                .catch(errors => this.handleFailure(errors, this.clienteForm))
                .finally(() => this.apply())
        }
    }

    perfilPagamentoSubmit(form) {
        if (form && form.$valid) {
            const submitFunction = () => {
                const promise = this.paymentMethodCode == "credit_card" && !this.perfilPagamento.id
                    ? this.createPerfilPagamento({ ...this.perfilPagamento })
                    : this.updateContrato(this.contrato, { paymentMethodCode: this.paymentMethodCode })

                this.metodoPagamentoSavePromise = promise
                    .then((contrato) => {
                        this.clienteForm.$setPristine()
                        form.$setPristine()
                        form.saveFailed = false
                        form.saveSuccess = true
                        this.timeout(() => form.saveSuccess = false, 1000)
                        this.selectContrato(contrato)
                    })
                    .catch(errors => this.handleFailure(errors, form))
                    .finally(() => this.apply())
            }

            if ((this.paymentMethodCode != this.contrato.paymentMethodCode) && this.perfilPagamento && this.perfilPagamento.id) {
                const metodoPagamento = this.paymentMethodCode == "bank_slip" ? "Boleto" : "Cartão de crédito"

                Confirm.warning(
                    "Você tem certeza?",
                    `A sua próxima fatura será cobrada utilizando o método de pagamento "${metodoPagamento}".`,
                    {
                        'Cancelar': angular.noop,
                        'Sim, tenho certeza': submitFunction
                    })
            } else {
                submitFunction()
            }
        }
    }

    removePerfilPagamentoCartaoCredito() {
        Confirm.warning(
            "Você tem certeza?",
            "Caso não informe um novo método de pagamento, sua assinatura eventualmente entrará no estado de inadimplência.",
            {
                'Cancelar': angular.noop,
                'Sim, tenho certeza': () => {
                    this.apply(() => {
                        this.metodoPagamentoSavePromise = this.deletePerfilPagamento(this.perfilPagamento.id)
                            .then((contrato) => {
                                this.clienteForm.$setPristine()
                                this.perfilPagamentoCartaoCreditoForm.saveFailed = false
                                this.perfilPagamentoCartaoCreditoForm.saveSuccess = true
                                this.timeout(() => this.perfilPagamentoCartaoCreditoForm.saveSuccess = false, 1000)
                                this.selectContrato(contrato)
                            })
                            .catch(errors => this.handleFailure(errors, this.perfilPagamentoCartaoCreditoForm))
                            .finally(() => this.apply())
                    })
                }
            })
    }

    maybeBuscarCnpj() {
        const cpfCnpj = this.cliente.cpfCnpj

        if (cpfCnpj && cpfCnpj.length == 14) {
            this.loadDadosCadastrais(cpfCnpj)
                .then(({ filial: { razaoSocial } }) => {
                    this.apply(() => this.cliente.nome = razaoSocial)
                    this.setFocusToInput("email")
                })
        }
    }

    buscarCep() {
        const cep = this.cliente.cep

        if (cep && cep.length == 8) {
            this.cepNotFound = false

            this.http({ method: 'GET', url: env.external_url + `/viacep.com.br/ws/${cep}/json`, withCredentials: false })
                .then(({ data }) => {
                    if (data.erro) {
                        this.cepNotFound = true
                    } else {
                        const { logradouro, bairro, localidade, uf } = data

                        this.cliente = {
                            ...this.cliente,
                            endereco: logradouro,
                            cidade: { nome: localidade, estado: { sigla: uf } },
                            bairro
                        }

                        this.setFocusToInput("numero")
                    }
                })
                .finally(() => this.apply())
        } else {
            this.cliente = { ...this.cliente, endereco: "", numero: "", bairro: "", cidade: "" }
        }
    }

    loadCidades(nomeSearch) {
        const query = gql`
            query Cidades($nomeSearch: String, $codigoIbge: String){
                cidades(nomeSearch: $nomeSearch, codigoIbge: $codigoIbge, limit: 10) {
                    id
                    nome
                    estado {
                        id
                        sigla
                    }
                }
            }
        `

        return this.cidadesPromise = this.gql
            .query(query, { nomeSearch })
            .then(({ cidades }) => this.cidades = cidades)
            .finally(() => this.apply())
    }

    loadDadosCadastrais(cnpj) {
        const query = gql`
            query DadosCadastrais($cnpj: String!) {
                filial: dadosCadastrais(cnpj: $cnpj) {
                    razaoSocial
                    cnpj
                    cidade {
                        id
                        nome
                        estado {
                            id
                            sigla
                        }
                    }
                }
            }
        `

        return this.gql.query(query, { cnpj })
    }

    loadContratos() {
        const query = gql`
            query ContratosList {
                usuarioAtual {
                    id
                    contratos {
                        id
                        paymentMethodCode
                        cliente {
                            ${Contratos.clienteFields}
                            perfilPagamento {
                                ${Contratos.perfilPagamentoFields}
                            }
                        }
                    }
                }
            }
        `

        return this.gql
            .query(query)
            .then(({ usuarioAtual: { contratos } }) => contratos)
    }

    createContrato(contrato) {
        const mutation = gql`
            mutation CreateContrato($params: ContratoClienteParams!) {
                contrato: createContrato(params: $params) {
                    id
                    paymentMethodCode
                    cliente {
                        ${Contratos.clienteFields}
                        perfilPagamento {
                            ${Contratos.perfilPagamentoFields}
                        }
                    }
                }
            }
        `

        const { id, ...params } = { ...contrato.cliente }

        return this.gql
            .mutate(mutation, { params })
            .then(({ contrato }) => {
                if (contrato) {
                    this.contratos = [contrato, ...this.contratos]

                    return contrato
                }
            })
    }

    updateContrato(contrato, params) {
        const mutation = gql`
            mutation UpdateContrato($contratoId: String!, $params: ContratoParams!) {
                contrato: updateContrato(contratoId: $contratoId, params: $params) {
                    id
                    paymentMethodCode
                    cliente {
                        ${Contratos.clienteFields}
                        perfilPagamento {
                            ${Contratos.perfilPagamentoFields}
                        }
                    }
                }
            }
        `

        return this.gql
            .mutate(mutation, { contratoId: contrato.id, params })
            .then(({ contrato }) => {
                if (contrato) {
                    const index = this.contratos.findIndex((c) => c.id == contrato.id)

                    this.contratos[index] = contrato

                    return contrato
                }
            })
    }

    updateContratoCliente(contrato) {
        const mutation = gql`
            mutation UpdateContratoCliente($contratoId: String!, $params: ContratoClienteParams!) {
                contrato: updateContratoCliente(contratoId: $contratoId, params: $params) {
                    id
                    paymentMethodCode
                    cliente {
                        ${Contratos.clienteFields}
                        perfilPagamento {
                            ${Contratos.perfilPagamentoFields}
                        }
                    }
                }
            }
        `

        const { id, $$hashKey, __typename, ...params } = { ...contrato.cliente }

        return this.gql
            .mutate(mutation, { contratoId: contrato.id, params })
            .then(({ contrato }) => {
                if (contrato) {
                    const index = this.contratos.findIndex((p) => p.id == contrato.id)

                    this.contratos[index] = contrato

                    return contrato
                }
            })
    }

    createPerfilPagamento(perfilPagamento) {
        const mutation = gql`
            mutation CreateClientePerfilPagamento($clienteId: String!, $params: ContratoClientePerfilPagamentoParams!) {
                perfilPagamento: createClientePerfilPagamento(clienteId: $clienteId, params: $params) {
                    ${Contratos.perfilPagamentoFields}
                }
            }
        `

        const variables = { clienteId: this.cliente.id, params: perfilPagamento }

        return this.gql
            .mutate(mutation, variables)
            .then(({ perfilPagamento }) => {
                if (perfilPagamento) {
                    let contrato = this.contratos.find((p) => p.cliente.id == this.cliente.id)

                    contrato.cliente.perfilPagamento = perfilPagamento
                    contrato.paymentMethodCode = perfilPagamento.codigoMetodoPagamento

                    return contrato
                }
            })
    }

    deletePerfilPagamento(perfilPagamentoId) {
        const mutation = gql`
            mutation DeleteClientePerfilPagamento($perfilPagamentoId: String!) {
                perfilPagamento: deleteClientePerfilPagamento(perfilPagamentoId: $perfilPagamentoId) {
                    id
                }
            }
        `

        return this.gql
            .mutate(mutation, { contratoId: this.contrato.id, perfilPagamentoId })
            .then(({ perfilPagamento }) => {
                if (perfilPagamento) {
                    let contrato = this.contratos.find((p) => p.cliente.id == this.cliente.id)

                    contrato.cliente.perfilPagamento = null
                    contrato.paymentMethodCode = null

                    return contrato
                }
            })
    }

    handleFailure(errors, form) {
        const parsedKeys = {
            "validade_cartao": "Validade do cartão"
        }

        const formErrors = errors && errors.filter(e => e.key).map(({ key, message }) => {
            return `O valor informado no campo "${parsedKeys[key]}" ${message}.`
        })

        const defaultError = "Ocorreu um erro inesperado. Por favor, contate o suporte."

        form.saveFailed = true

        this.errors = formErrors && formErrors.length ? formErrors : [defaultError]
    }

    static get clienteFields() {
        return `
            id
            nome
            cpfCnpj
            email
            cep
            endereco
            numero
            bairro
            cidade
            estado
        `
    }

    static get perfilPagamentoFields() {
        return `
            id
            nomeTitular
            numeroCartaoPrimeirosSeis
            numeroCartaoUltimosQuatro
            validadeCartao
            codigoBancoBandeira
            codigoMetodoPagamento
        `
    }
}

angular.module("eficienciaFiscalModule")
    .component("contratos", {
        controller: Contratos,
        template: `
            <h2 style="margin: 20px">
                <i class="fa fa-credit-card"></i>
                Contratos
            </h2>
            <hr class="no-margin" />
            <loading promise="$ctrl.initialPromise">
                <div class="main">
                    <div class="contratos-container">
                        <div class="form-busca">
                            <a class="btn btn-info" href="/contratos/novo">
                                Adicionar
                            </a>
                            <div class="input-icon">
                                <input
                                    ng-model="$ctrl.search"
                                    placeholder="Digite aqui para filtrar"
                                    class="form-control"/>
                                <i class="fa fa-search icon"></i>
                            </div>
                        </div>

                        <promise-tracker promise="$ctrl.clienteSavePromise" active="isLoading">
                            <h5 ng-if="isLoading">
                                <i class="fa fa-circle-o-notch fa-spin"></i>
                                Carregando...
                            </h5>

                            <div ng-if="!isLoading">
                                <a 
                                    class="contrato"
                                    ng-repeat="contrato in $ctrl.contratos | filter: $ctrl.search" 
                                    ng-href="/contratos/{{ contrato.id }}"
                                    ng-class="{'contrato-selected': $ctrl.contrato.id == contrato.id}"
                                    title="{{contrato.cliente.nome}}">
                                    <div class="nome">
                                        <div style="flex-grow: 1;">{{contrato.cliente.nome}}</div>
                                        <div style="margin-left: 5px; white-space: nowrap">
                                            <small class="text-muted">{{contrato.cliente.cpfCnpj | cpfCnpj}}</small>
                                        </div>
                                        <div>
                                            <i
                                                class="fa fa-exclamation-triangle text-warning"
                                                style="margin-left: 3px;"
                                                ng-if="contrato.paymentMethodCode == 'credit_card' && !contrato.cliente.perfilPagamento"
                                                tooltip="Existem problemas na configuração deste contrato."></i>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </promise-tracker>
                    </div>

                    <div class="no-profile-select" ng-if="!$ctrl.contrato">
                        <highlighted>
                            <main>Nenhum contrato selecionado.</main>
                            <secondary>
                                Selecione um contrato na lista à esquerda ou 
                                <a href="/contratos/novo">clique aqui</a> 
                                para criar um.
                            </secondary>
                        </highlighted>
                    </div>

                    <div class="cadastro-container" ng-if="$ctrl.contrato">
                        <div class="dados-contrato">
                            <promise-tracker promise="$ctrl.clienteSavePromise" active="isClienteSaving">
                                <form name="$ctrl.clienteForm" ng-submit="$ctrl.clienteFormSubmit()" novalidate>
                                    <a class="pull-right" style="font-size: 14px" ng-if="$ctrl.contrato.id" ng-href="/contratos/{{ $ctrl.contrato.id }}/detalhamento">
                                        Visualizar detalhamento de utilização
                                    </a>

                                    <h5>Dados do titular</h5>

                                    <div class="row">
                                        <div class="form-group col-xs-12 col-md-4">
                                            <label>CPF/CNPJ</label>
                                            <input
                                                name="cpfCnpj" 
                                                class="form-control"    
                                                ng-model="$ctrl.cliente.cpfCnpj"
                                                ng-disabled="isClienteSaving"
                                                ng-change="$ctrl.maybeBuscarCnpj()"
                                                ui-br-cpfcnpj-mask
                                                autofocus
                                                required />
                                            <div ng-messages="$ctrl.clienteForm.cpfCnpj.$error" ng-if="$ctrl.clienteForm.$submitted">
                                                <span 
                                                    class="help-block txt-color-red font-xs no-margin"
                                                    ng-message="required">Este campo é obrigatório.
                                                </span>
                                                <span 
                                                    class="help-block txt-color-red font-xs no-margin"
                                                    ng-message="cpf">CPF inválido.
                                                </span>
                                                <span 
                                                    class="help-block txt-color-red font-xs no-margin"
                                                    ng-message="cnpj">CNPJ inválido.
                                                </span>
                                            </div>
                                        </div>

                                        <div class="form-group col-xs-12 col-md-8">
                                            <label>Nome</label>
                                            <input 
                                                name="nome" 
                                                class="form-control"    
                                                ng-model="$ctrl.cliente.nome"
                                                ng-disabled="isClienteSaving"
                                                required />
                                            <div ng-messages="$ctrl.clienteForm.nome.$error" ng-if="$ctrl.clienteForm.$submitted">
                                                <span 
                                                    class="help-block txt-color-red font-xs no-margin"
                                                    ng-message="required">Este campo é obrigatório.
                                                </span>
                                            </div>
                                        </div>

                                        <div class="form-group col-xs-12 col-md-8">
                                            <label>E-mail</label>
                                            <input 
                                                name="email" 
                                                type="email" 
                                                class="form-control"    
                                                ng-model="$ctrl.cliente.email"
                                                ng-disabled="isClienteSaving"
                                                required />
                                            <div ng-messages="$ctrl.clienteForm.email.$error" ng-if="$ctrl.clienteForm.$submitted">
                                                <span 
                                                    class="help-block txt-color-red font-xs no-margin"
                                                    ng-message="required">Este campo é obrigatório.
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <h5>Endereço</h5>

                                    <div class="row">
                                        <div class="form-group col-xs-12 col-md-3">
                                            <label>CEP</label>
                                            <input 
                                                name="cep" 
                                                class="form-control"    
                                                ng-model="$ctrl.cliente.cep"
                                                ng-change="$ctrl.buscarCep()"
                                                ng-disabled="isClienteSaving"
                                                ng-class="{'shake': $ctrl.cepNotFound}"
                                                ui-mask="99.999-999"
                                                required />
                                            <div ng-messages="$ctrl.clienteForm.cep.$error" ng-if="$ctrl.clienteForm.$submitted">
                                                <span 
                                                    class="help-block txt-color-red font-xs no-margin"
                                                    ng-message="required">Este campo é obrigatório.
                                                </span>
                                            </div>
                                        </div>

                                        <div class="form-group col-xs-12 col-md-7">
                                            <label>Rua ou Avenida</label>
                                            <input 
                                                name="endereco" 
                                                class="form-control"  
                                                ng-model="$ctrl.cliente.endereco"
                                                ng-disabled="isClienteSaving"
                                                required />
                                            <div ng-messages="$ctrl.clienteForm.endereco.$error" ng-if="$ctrl.clienteForm.$submitted">
                                                <span 
                                                    class="help-block txt-color-red font-xs no-margin"
                                                    ng-message="required">Este campo é obrigatório.
                                                </span>
                                            </div>
                                        </div>

                                        <div class="form-group col-xs-12 col-md-2">
                                            <label>Número</label>
                                            <input 
                                                name="numero" 
                                                class="form-control"
                                                ng-model="$ctrl.cliente.numero"
                                                ng-disabled="isClienteSaving"
                                                required />
                                            <div ng-messages="$ctrl.clienteForm.numero.$error" ng-if="$ctrl.clienteForm.$submitted">
                                                <span 
                                                    class="help-block txt-color-red font-xs no-margin"
                                                    ng-message="required">Este campo é obrigatório.
                                                </span>
                                            </div>
                                        </div>

                                        <div class="form-group col-xs-12 col-md-6">
                                            <label>Bairro</label>
                                            <input 
                                                name="bairro" 
                                                class="form-control"    
                                                ng-model="$ctrl.cliente.bairro"
                                                ng-disabled="isClienteSaving"
                                                required />
                                            <div ng-messages="$ctrl.clienteForm.bairro.$error" ng-if="$ctrl.clienteForm.$submitted">
                                                <span 
                                                    class="help-block txt-color-red font-xs no-margin"
                                                    ng-message="required">Este campo é obrigatório.
                                                </span>
                                            </div>
                                        </div>

                                        <promise-tracker promise="$ctrl.cidadesPromise" active="isCidadeLoading">
                                            <div class="form-group col-xs-12 col-md-6">
                                                <label>Cidade</label>

                                                <span class="spinner" ng-if="isCidadeLoading">
                                                    <i class="fa fa-circle-o-notch fa-spin"></i>
                                                </span>

                                                <ui-select 
                                                    theme="bootstrap" 
                                                    name="cidade" 
                                                    ng-model="$ctrl.cliente.cidade"
                                                    ng-class="{'spinner-select': isCidadeLoading}"
                                                    ng-disabled="isClienteSaving"
                                                    reset-search-input="false"
                                                    required>
                                                    <ui-select-match>
                                                        {{$select.selected.nome}} - {{$select.selected.estado.sigla}}
                                                    </ui-select-match>
                                                    <ui-select-choices 
                                                        repeat="cidade in $ctrl.cidades"
                                                        refresh="$ctrl.loadCidades($select.search)"
                                                        refresh-delay="500">
                                                        <div>{{cidade.nome}} - {{cidade.estado.sigla}}</div>
                                                    </ui-select-choices>
                                                </ui-select>

                                                <div ng-messages="$ctrl.clienteForm.cidade.$error" ng-if="$ctrl.clienteForm.$submitted">
                                                    <span 
                                                        class="help-block txt-color-red font-xs no-margin"
                                                        ng-message="required">Este campo é obrigatório.
                                                    </span>
                                                </div>
                                            </div>
                                        </promise-tracker>
                                    </div>

                                    <div class="row">
                                        <div class="col-xs-12 col-md-3">
                                            <button class="btn btn-primary btn-block" ng-disabled="isClienteSaving">
                                                <span ng-if="isClienteSaving">
                                                    <i class="fa fa-circle-o-notch fa-spin"></i>
                                                </span>
                                                {{ isClienteSaving ? 'Salvando...' : 'Salvar' }}
                                            </button>
                                        </div>

                                        <div class="col-xs-12 col-md-9">
                                            <div
                                                class="text-success fade-animation"
                                                style="margin-top: 10px;"
                                                ng-show="$ctrl.clienteForm.saveSuccess">
                                                <i class="fa fa-check"></i> Salvo com sucesso!
                                            </div>
                                            <div
                                                class="text-danger fade-animation"
                                                style="margin-top: 10px;"
                                                ng-show="$ctrl.clienteForm.saveFailed">
                                                <i class="fa fa-times" ng-repeat="error in $ctrl.errors">
                                                    {{ error }}
                                                </i>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </promise-tracker>

                            <hr/>

                            <promise-tracker promise="$ctrl.metodoPagamentoSavePromise" active="isMetodoPagamentoSaving">
                                <h5>Método de pagamento</h5>

                                <div ng-if="!$ctrl.cliente.id">
                                    Cadastre os dados acima para poder informar um método de pagamento.
                                </div>

                                <div ng-if="$ctrl.cliente.id">
                                    <div style="display: flex; flex-wrap: wrap; margin-bottom: 10px;">
                                        <div style="flex-grow: 1;">
                                            <div class="smart-form inline-group">
                                                <label class="radio no-break">
                                                    <input
                                                        type="radio"
                                                        ng-model="$ctrl.paymentMethodCode"
                                                        value="bank_slip">
                                                    <i></i> Boleto
                                                </label>

                                                <label class="radio no-break">
                                                    <input
                                                        type="radio"
                                                        ng-model="$ctrl.paymentMethodCode"
                                                        value="credit_card">
                                                    <i></i> Cartão de crédito
                                                    <div style="display: inline; white-space: normal;">
                                                        <span
                                                            class="fa fa-exclamation-triangle text-warning"
                                                            ng-if="$ctrl.contrato.paymentMethodCode == 'credit_card' && !$ctrl.perfilPagamento.id"
                                                            tooltip="O contrato está configurado com este método de pagamento porém não existe um cartão de crédito cadastrado.">
                                                        </span>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>

                                        <div style="align-self: flex-end;" ng-if="$ctrl.paymentMethodCode == 'credit_card' && !$ctrl.perfilPagamento.id">
                                            <div class="input-group">
                                                <div class="input-group-btn" style="width: inherit;">
                                                    <img
                                                        src="/assets/img/bandeiras_bancos/mastercard.png"
                                                        class="btn btn-xs bandeira"
                                                        width="50px"
                                                        ng-model="$ctrl.perfilPagamento.codigoBancoBandeira"
                                                        ng-class="{'bandeira-selecionada': $ctrl.perfilPagamento.codigoBancoBandeira == 'mastercard'}"
                                                        btn-radio="'mastercard'"
                                                        style="opacity: 1"
                                                        disabled />
                                                    <img
                                                        src="/assets/img/bandeiras_bancos/visa.png"
                                                        class="btn btn-xs bandeira"
                                                        width="50px"
                                                        ng-model="$ctrl.perfilPagamento.codigoBancoBandeira"
                                                        ng-class="{'bandeira-selecionada': $ctrl.perfilPagamento.codigoBancoBandeira == 'visa'}"
                                                        btn-radio="'visa'"
                                                        style="opacity: 1"
                                                        disabled />
                                                    <img
                                                        src="/assets/img/bandeiras_bancos/elo.png"
                                                        class="btn btn-xs bandeira"
                                                        width="50px"
                                                        ng-model="$ctrl.perfilPagamento.codigoBancoBandeira"
                                                        ng-class="{'bandeira-selecionada': $ctrl.perfilPagamento.codigoBancoBandeira == 'elo'}"
                                                        btn-radio="'elo'"
                                                        style="opacity: 1"
                                                        disabled />
                                                    <img
                                                        src="/assets/img/bandeiras_bancos/hipercard.png"
                                                        class="btn btn-xs bandeira"
                                                        width="50px"
                                                        ng-model="$ctrl.perfilPagamento.codigoBancoBandeira"
                                                        ng-class="{'bandeira-selecionada': $ctrl.perfilPagamento.codigoBancoBandeira == 'hipercard'}"
                                                        btn-radio="'hipercard'"
                                                        style="opacity: 1"
                                                        disabled />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <form
                                        name="$ctrl.perfilPagamentoBoletoForm"
                                        ng-submit="$ctrl.perfilPagamentoSubmit($ctrl.perfilPagamentoBoletoForm)"
                                        ng-if="$ctrl.paymentMethodCode == 'bank_slip'"
                                        novalidate>
                                        <div class="row">
                                            <div class="form-group col-xs-12 col-md-2" ng-hide="$ctrl.contrato.paymentMethodCode == 'bank_slip'">
                                                <button class="btn btn-primary btn-block" ng-disabled="isMetodoPagamentoSaving">
                                                    <span ng-if="isMetodoPagamentoSaving">
                                                        <i class="fa fa-circle-o-notch fa-spin"></i>
                                                    </span>
                                                    {{ isMetodoPagamentoSaving ? 'Salvando...' : 'Salvar' }}
                                                </button>
                                            </div>

                                            <div class="form-group col-xs-12 col-md-10">
                                                <div
                                                    class="text-success fade-animation"
                                                    style="margin-top: 10px;"
                                                    ng-show="$ctrl.perfilPagamentoBoletoForm.saveSuccess">
                                                    <i class="fa fa-check"></i> Salvo com sucesso!
                                                </div>
                                                <div
                                                    class="text-danger fade-animation"
                                                    style="margin-top: 10px;"
                                                    ng-show="$ctrl.perfilPagamentoBoletoForm.saveFailed">
                                                    <i class="fa fa-times" ng-repeat="error in $ctrl.errors">
                                                        {{ error }}
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                    <form
                                        name="$ctrl.perfilPagamentoCartaoCreditoForm"
                                        ng-submit="$ctrl.perfilPagamentoSubmit($ctrl.perfilPagamentoCartaoCreditoForm)"
                                        ng-if="$ctrl.paymentMethodCode == 'credit_card'"
                                        novalidate>
                                        <div class="row" ng-if="!$ctrl.perfilPagamento.id">
                                            <div class="form-group col-xs-12 col-md-4">
                                                <label>Nome do titular</label>
                                                <input 
                                                    class="form-control"    
                                                    name="nomeTitular" 
                                                    ng-model="$ctrl.perfilPagamento.nomeTitular"
                                                    ng-disabled="isMetodoPagamentoSaving"
                                                    required />
                                                <div
                                                    ng-messages="$ctrl.perfilPagamentoCartaoCreditoForm.nomeTitular.$error"
                                                    ng-if="$ctrl.perfilPagamentoCartaoCreditoForm.$submitted">
                                                    <span 
                                                        class="help-block txt-color-red font-xs no-margin"
                                                        ng-message="required">Este campo é obrigatório.
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="form-group col-xs-12 col-md-4">
                                                <label>Número do cartão</label>
                                                <input 
                                                    class="form-control"    
                                                    name="numeroCartao" 
                                                    ng-model="$ctrl.perfilPagamento.numeroCartao"
                                                    ng-change="$ctrl.identificarBandeiraCartao()"
                                                    ng-disabled="isMetodoPagamentoSaving"
                                                    ui-mask="9999 9999 9999 9999"
                                                    ui-mask-placeholder=" "
                                                    required />
                                                <div
                                                    ng-messages="$ctrl.perfilPagamentoCartaoCreditoForm.numeroCartao.$error"
                                                    ng-if="$ctrl.perfilPagamentoCartaoCreditoForm.$submitted">
                                                    <span 
                                                        class="help-block txt-color-red font-xs no-margin"
                                                        ng-message="required">Este campo é obrigatório.
                                                    </span>
                                                    <span 
                                                        class="help-block txt-color-red font-xs no-margin"
                                                        ng-message="unsupported">Cartão não suportado.
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="form-group col-xs-12 col-md-2">
                                                <label>Validade</label>
                                                <input 
                                                    class="form-control"    
                                                    name="validadeCartao" 
                                                    ng-model="$ctrl.perfilPagamento.validadeCartao"
                                                    ng-disabled="isMetodoPagamentoSaving"
                                                    ui-mask="99/9999"
                                                    ui-mask-return="true"
                                                    placeholder="MM/AAAA"
                                                    required />
                                                <div
                                                    ng-messages="$ctrl.perfilPagamentoCartaoCreditoForm.validadeCartao.$error"
                                                    ng-if="$ctrl.perfilPagamentoCartaoCreditoForm.$submitted">
                                                    <span 
                                                        class="help-block txt-color-red font-xs no-margin"
                                                        ng-message="required">Este campo é obrigatório.
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="form-group col-xs-12 col-md-2">
                                                <label>CVV</label>
                                                <input 
                                                    class="form-control"
                                                    name="cvvCartao" 
                                                    ng-model="$ctrl.perfilPagamento.cvvCartao"
                                                    ng-disabled="isMetodoPagamentoSaving"
                                                    ui-mask="999"
                                                    ui-mask-placeholder=" "
                                                    required />
                                                <div
                                                    ng-messages="$ctrl.perfilPagamentoCartaoCreditoForm.cvvCartao.$error"
                                                    ng-if="$ctrl.perfilPagamentoCartaoCreditoForm.$submitted">
                                                    <span 
                                                        class="help-block txt-color-red font-xs no-margin"
                                                        ng-message="required">Este campo é obrigatório.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div ng-if="$ctrl.perfilPagamento.id">        
                                            <div class="well metodo-pagamento" style="display: flex; align-items: center;">
                                                <div>
                                                    <img
                                                        ng-src="/assets/img/bandeiras_bancos/{{ $ctrl.perfilPagamento.codigoBancoBandeira }}.png"
                                                        style="padding: 1px 5px;"
                                                        width="70px"/>
                                                </div>

                                                <div style="flex-grow: 1;">
                                                    <span class="text-muted">Portador</span> 
                                                    {{ $ctrl.perfilPagamento.nomeTitular }}
            
                                                    <span class="text-muted">Final</span> 
                                                    {{ $ctrl.perfilPagamento.numeroCartaoUltimosQuatro }}
            
                                                    <span class="text-muted">Validade</span> 
                                                    {{ $ctrl.perfilPagamento.validadeCartao | date: 'MM/yyyy' }}
                                                </div>

                                                <div>
                                                    <button
                                                        type="button"
                                                        class="btn btn-link btn-xs"
                                                        ng-click="$ctrl.removePerfilPagamentoCartaoCredito()">
                                                        Remover
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div
                                                class="form-group col-xs-12 col-md-2"
                                                ng-hide="$ctrl.contrato.paymentMethodCode == 'credit_card' && $ctrl.perfilPagamento.id">
                                                <button class="btn btn-primary btn-block" ng-disabled="isMetodoPagamentoSaving">
                                                    <span ng-if="isMetodoPagamentoSaving">
                                                        <i class="fa fa-circle-o-notch fa-spin"></i>
                                                    </span>
                                                    {{ isMetodoPagamentoSaving ? 'Salvando...' : 'Salvar' }}
                                                </button>
                                            </div>

                                            <div class="form-group col-xs-12 col-md-10">
                                                <div
                                                    class="text-success fade-animation"
                                                    style="margin-top: 10px;"
                                                    ng-show="$ctrl.perfilPagamentoCartaoCreditoForm.saveSuccess">
                                                    <i class="fa fa-check"></i> Salvo com sucesso!
                                                </div>
                                                <div
                                                    class="text-danger fade-animation"
                                                    style="margin-top: 10px;"
                                                    ng-show="$ctrl.perfilPagamentoCartaoCreditoForm.saveFailed">
                                                    <i class="fa fa-times" ng-repeat="error in $ctrl.errors">
                                                        {{ error }}
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </promise-tracker>
                        </div>
                    </div>
                </div>
            </loading>
        `
    })
